module.exports = __webpack_public_path__ + "img/game_item_bg.65e6d046.png";